import { render, staticRenderFns } from "./IDVerifLanding.vue?vue&type=template&id=f2ecda58&"
import script from "./IDVerifLanding.vue?vue&type=script&lang=js&"
export * from "./IDVerifLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports